import React from 'react'

const TranslationPageLayout = ({ children }) => {
    return (
        <div className='min-h-screen flex items-center flex-col pt-2'>
            <div className='w-full min-w-[384px] m-auto flex items-center flex-col gap-5 pt-2.5 px-5'>
                {children}
            </div>
        </div>
    )
}

export default TranslationPageLayout
